import { Filter, FilterType } from "./types";

export const languageFilter: Filter = {
  filterName: "Language",
  type: FilterType.LANGUAGE,
  filterItems: [
    {
      name: "Language",
      filterLabel: "English",
      value: "english",
      checked: false,
    },
    {
      name: "Language",
      filterLabel: "French",
      value: "french",
      checked: false,
    },
    {
      name: "Language",
      filterLabel: "German",
      value: "german",
      checked: false,
    },
    {
      name: "Language",
      filterLabel: "Japanese",
      value: "japanese",
      checked: false,
    },
    {
      name: "Language",
      filterLabel: "Spanish",
      value: "spanish",
      checked: false,
    },
  ],
};

export const checkedFilter = {
  filterName: "Checked",
  type: FilterType.CHECKED,
  filterItems: [
    {
      filterLabel: "yes",
      value: "yes",
      checked: false,
    },
    {
      filterLabel: "no",
      value: "no",
      checked: false,
    },
  ],
};

export const initialFilters: Filter[] = [checkedFilter, languageFilter];
